module.exports = __webpack_public_path__ + "static/img/15bg.38566a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/15bg.png
// module id = rbE3
// module chunks = 1